import { Badge, Flex, Text, useTheme } from "@chakra-ui/react";
import { Buildings, CalendarBlank } from "@phosphor-icons/react";
import { AButton } from "../../../../components/A";
import { routes } from "../../../../config/paths";
import { formatPeriod } from "../../../../utils/financialYear";

/**
 * The workstream's entity and reporting period, for the foundation question page's Manage tray — in the same
 * label-over-value shape as the tray's Stage / Owner / Assignees (ManageAnswer), so they read as one panel.
 *
 * The period line is ESG-4018's: what extraction collects for this workstream. Targets is not period-filtered
 * (its base and target years are other years by design), so it shows no dates there rather than ones it
 * ignores. The settings link is for whoever can change the financial year (ORG_ADMIN).
 */
export default function FoundationWorkstreamDetails({ dataYear, canEditFinancialYear }) {
  const { colors } = useTheme();
  if (!dataYear) return null;
  const showPeriod = dataYear.filtersByPeriod && dataYear.periodStart;

  return (
    <>
      {dataYear.entityName ? (
        <Flex direction="column" gap={2}>
          <Flex gap={2} align="center">
            <Buildings size={18} color={colors.gray[400]} />
            <Text variant="statusTitle">Entity</Text>
          </Flex>
          <Badge px={2} py={1} borderRadius="md" fontSize="body.xxs" colorScheme="gray" width="fit-content">
            {dataYear.entityName}
          </Badge>
        </Flex>
      ) : null}

      {showPeriod || canEditFinancialYear ? (
        <Flex direction="column" gap={2}>
          <Flex gap={2} align="center">
            <CalendarBlank size={18} color={colors.gray[400]} />
            <Text variant="statusTitle">Reporting period</Text>
          </Flex>
          {showPeriod ? (
            <Text fontSize="body.xs" color="gray.700">
              {formatPeriod({ start: dataYear.periodStart, end: dataYear.periodEnd })}
              {dataYear.periodOverridden ? " (set for this year)" : ""}
            </Text>
          ) : (
            <Text fontSize="body.xs" color="gray.500">
              Not limited to a period for this workstream.
            </Text>
          )}
          {canEditFinancialYear ? (
            <AButton
              href={routes.settingsFinancialYear}
              variant="link"
              fontSize="body.xs"
              color="limeShade.600"
              width="fit-content"
            >
              Financial year settings
            </AButton>
          ) : null}
        </Flex>
      ) : null}
    </>
  );
}
